'use strict'

export class ProductController {
  static findDuplicateSections(): void {
    type SectionData = {
      h2Text: string
      badgeText: string
      paragraphText: string
      section: HTMLElement
    }

    const sections: SectionData[] = []

    const allSections = document.querySelectorAll('section')

    allSections.forEach(section => {
      const h2Element = section.querySelector('h2')
      const badgeElement = section.querySelector('.badge')
      const paragraphElement = section.querySelector(
        'div.pt-xl-2d5.pt-lg-1d5.pt-1d0 p'
      )

      if (h2Element && badgeElement) {
        const h2Text = h2Element.textContent?.trim() || ''
        const badgeText = badgeElement.textContent?.trim() || ''
        const paragraphText = paragraphElement?.textContent?.trim() || ''

        const completeMatchIndex = sections.findIndex(
          data =>
            data.h2Text === h2Text &&
            data.badgeText === badgeText &&
            data.paragraphText === paragraphText
        )

        const titleAndBadgeMatchIndex = sections.findIndex(
          data =>
            data.h2Text === h2Text &&
            data.badgeText === badgeText &&
            data.paragraphText !== paragraphText
        )

        const titleOnlyMatchIndex = sections.findIndex(
          data =>
            data.h2Text === h2Text &&
            data.badgeText !== badgeText &&
            data.paragraphText !== paragraphText
        )

        if (completeMatchIndex !== -1) {
          // eslint-disable-next-line no-console
          console.error(
            `Complete Match: Section "${h2Text}" has complete duplicates`
          )
        } else if (titleAndBadgeMatchIndex !== -1) {
          // eslint-disable-next-line no-console
          console.warn(
            `Title and Badge Match: Section "${h2Text}" has the same title and badge but different paragraphs`
          )
        } else if (titleOnlyMatchIndex !== -1) {
          // eslint-disable-next-line no-console
          console.info(
            `Title Only Match: Section "${h2Text}" has the same title but different badge and paragraphs`
          )
        } else {
          sections.push({h2Text, badgeText, paragraphText, section})
        }
      }
    })
  }
}
